import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import useTranslation from '../../hooks/use_translation';
import healthCheckIcon from '../../images/icons/health-check.svg';
import packegeIcon from '../../images/icons/packege.svg';
import singleIcon from '../../images/icons/single.svg';
import BtnIcon from '../framework/buttons/btn_icon';
import Link from '../framework/link';

const Offers = ({ color = 'white', variant = 'grid' }) => {
	const { t } = useTranslation('component_offers');

	// Data array for the offers
	const offersData = [
		{
			description: t('t3'),
			imageSrc: healthCheckIcon,
			title: t('t2'),
			to: '/halsokontroller',
		},
		{
			description: t('t5'),
			imageSrc: singleIcon,
			title: t('t4'),
			to: '/tester/',
		},
		{
			description: t('t7'),
			imageSrc: packegeIcon,
			title: t('t6'),
			to: '/halsokontroller#packages',
		},
	];

	const variants = { grid: 'col-lg-4', list: 'col-lg-12' };

	const colors = {
		light: 'bg-mint border-0 ',
		white: 'bg-white border-0 shadow-sm',
	};

	return (
		<div className="row align-items-start justify-content-between mt-3">
			{offersData.map((offer, index) => (
				<div className={`${variants[variant]} mb-2 mb-lg-2`} key={index}>
					<Link
						className={`card text-decoration-none rounded-3  ${colors[color]}`}
						to={offer.to}
					>
						<div
							className="card-body px-3 py-4 d-flex align-items-center justify-content-between"
							style={{ height: '6rem' }}
						>
							<div className="d-flex align-items-center">
								<div className="icon-md icon-contain me-3 bg-transparent rounded-3">
									<img alt={offer.title} className="" src={offer.imageSrc} />
								</div>
								<div>
									<h3 className="sm fw-700 mb-1">{offer.title}</h3>
									<p
										className={`xs  mb-0 ${color === 'light' ? 'text-success' : ''}`}
									>
										{offer.description}
									</p>
								</div>
							</div>

							<BtnIcon
								iconSize="md"
								labelSize="sm"
								linkType="div"
								variant="show_more_transparent"
							>
								<ArrowRightShort />
							</BtnIcon>
						</div>
					</Link>
				</div>
			))}
		</div>
	);
};

Offers.propTypes = {
	children: PropTypes.node,
	color: PropTypes.oneOf(['white', 'light']),
	variant: PropTypes.oneOf(['grid', 'list']),
};

export default Offers;
